<template>
  <div>
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fieldsTGrupo"
            :orderby="sortBy"
            :actions="actionsTGrupo"
            addFilter
            :items="listagemTipoGrupo"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldModal"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="criarTipo.idtipogrupo === 0 ? adicionarTGrupo() : editandoTGrupo()"
        >
          <div class="row">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="criarTipo.codigounico"
                >Código</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <input type="hidden" v-model="criarTipo.idtipogrupo" />
              <fccInput extraClasses="inputLabel" required v-model="criarTipo.descricao"
                >Tipo de Grupo</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Tipo de grupo',
      titlePDF: 'Lista de Tipo de grupo',
      titleModal: '',
      fieldsTGrupo: [
        { key: 'idtipogrupo', label: 'Id', sortable: false },
        { key: 'codigounico', label: 'Código', sortable: true },
        { key: 'descricao', label: 'Tipo', sortable: true },
        { key: 'actions', label: '' }
      ],
      itemPorPage: '100',
      listagemTipoGrupo: [],
      criarTipo: {},
      actionsTGrupo: [
        {
          button: true,
          funcaoButton: 'editTGrupo',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteTGrupo',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    listarTipoGrupo: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrlGestaoForm + 'TipoGrupo/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listagemTipoGrupo = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    deleteTGrupo: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlGestaoForm + 'TipoGrupo/Excluir/' + item.idtipogrupo,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarTipoGrupo()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    editTGrupo: function (_, item) {
      this.criarTipo = item
      this.titleModal = 'Editar tipo de grupo'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    addField: function () {
      this.criarTipo = {}
      this.criarTipo.idtipogrupo = 0
      this.titleModal = 'Adicionar tipo de grupo'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editandoTGrupo: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .post(
          this.baseUrlGestaoForm + 'TipoGrupo/Alterar',
          this.criarTipo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoGrupo()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionarTGrupo: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoForm + 'TipoGrupo',
          this.criarTipo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoGrupo()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlGestaoForm = store.state.baseUrlGestaoForm
    this.listarTipoGrupo()
  }
}
</script>
